<template lang="pug" src="./purchasePromotional.pug"></template>
<style lang="scss" src="./purchasePromotional.scss" scoped> </style>

<script>
import { mapState } from 'vuex'
import config from '../../../config.json'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import request from '@/utils/request'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        purchasePromoRate: config.purchasePromoRate,
        money: null,
        loading: false
    }),
    validations: {
        money: {
            required,
            decimal: function() {
                return Number(this.money) == this.money && this.money > 0
            },
            isEnoughMoney: function() {
                return this.money <= (+this.user.balance / 100)
            }
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.app.user
        }),
        promo() {
            const promo = this.purchasePromoRate * this.money
            return (promo % 1 === 0) ? promo : promo.toFixed(1)
        }
    },
    methods: {
        closePurchasePromoDialog() {
            this.$store.commit('SET_PURCHASE_PROMO_DIALOG', false)
        },

        buyBonusBalance() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            if (this.loading) return

            this.loading = true

            request({
                method: 'post',
                url: '/promo-balance/buy',
                data: { sum: this.money * 100 }
            }).then(res => {
                if (res.data) {
                    this.$store.commit('SET_BALANCE', res.data.balance)
                    this.$store.commit('SET_PROMO_BALANCE', res.data.promoBalance)

                    this.closePurchasePromoDialog()
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    this.$store.dispatch('addMessage', {
                        type: 'error',
                        message: err.response.data.message
                    }, { root: true })
                }
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
